export class EdgeCalculatorSettings {
    constructor() {
        this.sphericalMinDistance = 0.1;
        this.sphericalMaxDistance = 20;
        this.sphericalPreferredDistance = 2;
        this.sphericalMaxItems = 4;
        this.sphericalMaxStepTurnChange = Math.PI / 8;
        this.sphericalMaxVerticalMotion = 11 * (Math.PI / 180);
        this.sphericalMaxVerticalDistance = 4;
        this.rotationMaxDistance = this.turnMaxRigDistance;
        this.rotationMaxDirectionChange = Math.PI / 6;
        this.rotationMaxVerticalDirectionChange = Math.PI / 8;
        this.similarMaxDirectionChange = Math.PI / 8;
        this.similarMaxDistance = 12;
        this.similarMinTimeDifference = 12 * 3600 * 1000;
        this.stepMaxDistance = 20;
        this.stepMaxDirectionChange = Math.PI / 6;
        this.stepMaxDrift = Math.PI / 5;
        this.stepMaxDriftLeftRight = Math.PI / 3;
        this.stepPreferredDistance = 2;
        this.stepPreferredDistanceLeftRight = 4;
        this.stepMaxVerticalMotion = 11 * (Math.PI / 180);
        this.stepMaxVerticalDistance = 4;
        this.turnMaxDistance = 20;
        this.turnMaxDirectionChange = (2 * Math.PI) / 9;
        this.turnMaxRigDistance = 0.0;
        this.turnMinRigDirectionChange = Math.PI / 6;
        this.turnMaxMotionChange = (2 * Math.PI) / 9;
        this.turnMaxVerticalMotion = 11 * (Math.PI / 180);
        this.turnMaxVerticalDistance = 4;
    }
    get maxDistance() {
        return Math.max(this.sphericalMaxDistance, this.similarMaxDistance, this.stepMaxDistance, this.turnMaxDistance);
    }
    get maxVerticalDistance() {
        return Math.max(this.sphericalMaxVerticalDistance, this.stepMaxVerticalDistance, this.turnMaxVerticalDistance);
    }
}
//# sourceMappingURL=EdgeCalculatorSettings.js.map